import React, { useRef, useState } from 'react';
import OutsidePressHandler from 'react-native-outside-press';
import { useHover } from 'react-native-web-hooks';
import styled from 'styled-components/native';
import { Pressable } from 'react-native';
import _ from 'lodash';
import PropTypes from 'prop-types';
import DropDownItem from './drop-down-item';
import Colors from '../colors';
import Text from '../text';
import useDidMountEffect from '../hooks/use-did-mount-effect';
import Icon from '../icon';
const Container = styled(OutsidePressHandler)`
  position: relative;
`;
const DropDownLabel = styled.Pressable`
  padding-horizontal: 16px;
  padding-vertical: 8px;
  border-radius: 8px;
  background-color: ${_ref => {
  let {
    backgroundColor
  } = _ref;
  return backgroundColor;
}};
  flex-direction: row;
  align-items: center;
`;
const OptionsScroll = styled.ScrollView`
  max-height: ${(33.59 * 12).toFixed(2)}px;
  border-radius: 8px;
  position: absolute;
  top: 40px;

  shadow-color: ${Colors.black};
  shadow-offset: {
    width: 0px;
    height: 2px;
  }
  shadow-opacity: 0.25;
  shadow-radius: 3.84;
  elevation: 5;
`;
export default function DropDown(_ref2) {
  var _items$find;

  let {
    items,
    value,
    onChange
  } = _ref2;
  const ref = useRef(null);
  const hovered = useHover(ref);
  const [active, setActive] = useState(false);
  const [selected, setSelected] = useState(value);
  useDidMountEffect(() => onChange(selected), [onChange, selected]);
  useDidMountEffect(() => setSelected(value), [value]);
  return /*#__PURE__*/React.createElement(Container, {
    onOutsidePress: () => setActive(false)
  }, /*#__PURE__*/React.createElement(DropDownLabel, {
    ref: ref,
    onPress: () => setActive(!active),
    backgroundColor: hovered ? Colors.advanceBlue10 : Colors.white
  }, /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: hovered ? Colors.advanceBlue400 : Colors.gray600
  }, (_items$find = items.find(item => _.toString(item.value) === _.toString(selected))) === null || _items$find === void 0 ? void 0 : _items$find.label), /*#__PURE__*/React.createElement(Icon.MaterialCommunityIcons, {
    name: "chevron-down",
    size: 24,
    color: hovered ? Colors.advanceBlue400 : Colors.gray300
  })), active && /*#__PURE__*/React.createElement(OptionsScroll, null, items.map((item, index) => /*#__PURE__*/React.createElement(Pressable, {
    key: index,
    onPress: () => {
      setSelected(item.value);
      setActive(false);
    }
  }, /*#__PURE__*/React.createElement(DropDownItem, {
    item: item,
    selected: _.toString(item.value) === _.toString(selected)
  })))));
}
DropDown.defaultProps = {
  items: [],
  value: '',
  onChange: () => null
};
DropDown.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })),
  value: PropTypes.string,
  onChange: PropTypes.func
};
//# sourceMappingURL=drop-down.js.map